/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Footer_Link_TermsInputs */

const en_directory_footer_link_terms = /** @type {(inputs: Directory_Footer_Link_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terms`)
};

const zh_directory_footer_link_terms = /** @type {(inputs: Directory_Footer_Link_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`服务条款`)
};

/**
* | output |
* | --- |
* | "Terms" |
*
* @param {Directory_Footer_Link_TermsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_footer_link_terms = /** @type {((inputs?: Directory_Footer_Link_TermsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Footer_Link_TermsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_footer_link_terms(inputs)
	return zh_directory_footer_link_terms(inputs)
});
export { directory_footer_link_terms as "directory.footer.link_terms" }